export default function address() {
  return (value: string | null | undefined) => {
    if (!value || (!value.match(/[0-9\u2160-\u2169]/g) && !value.match(/[MDCLXVI]+\s*$/g))) {
      return 'required_feminine';
    }

    return null;
  };
}
